<figure class="route-map">
    <div class="route-map__stage">
        <div
            #mapCanvas
            class="route-map__canvas"
            [class.route-map__canvas--ready]="mapReady && !mapError"
            role="application"
            tabindex="0"
            [attr.aria-label]="routeLabel()"
        ></div>

        <button
            class="route-map__overlay"
            type="button"
            *ngIf="mapReady && !mapError && !wheelZoomUnlocked"
            (click)="unlockWheelZoom()"
            [attr.aria-label]="'Кликните по карте, чтобы включить масштабирование колесом'"
            title="Кликните по карте, чтобы включить масштабирование колесом"
        >
            <span class="route-map__overlay-chip">Кликните, чтобы включить зум колесом</span>
        </button>

        <div class="route-map__skeleton" *ngIf="!mapReady && !mapError" aria-hidden="true"></div>
        <span class="route-map__sr-only" *ngIf="!mapReady && !mapError" role="status">Карта загружается</span>
        <div class="route-map__error" *ngIf="mapError" role="status">
            Маршрут рассчитан, но карту загрузить не удалось.
        </div>
    </div>

    <figcaption
        [class.route-map__caption--visible]="mapReady && !mapError"
        [attr.aria-hidden]="mapReady && !mapError ? null : true"
    >
        <span class="route-map__attribution">
            <a href="https://openfreemap.org/" target="_blank" rel="noopener noreferrer">OpenFreeMap</a>
            <span aria-hidden="true">·</span>
            <a href="https://openmaptiles.org/" target="_blank" rel="noopener noreferrer">© OpenMapTiles</a>
            <span aria-hidden="true">·</span>
            <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">данные © OpenStreetMap</a>
            <span aria-hidden="true">·</span>
            <a href="https://openrouteservice.org/" target="_blank" rel="noopener noreferrer">маршрут © openrouteservice.org, HeiGIT</a>
        </span>
    </figcaption>
</figure>
